<template>
    <el-container >
         <!--首页左侧菜单栏-->
        <el-aside :width='asideWidth'> 
            <el-menu :default-active="$route.path"  :default-openeds="openeds"
                background-color="#000" text-color="#FFF" active-text-color="#FFFFFF"
                router  :collapse="isCollapse" :collapse-transition="false">
                <el-menu-item index="/welcome">
                    <i class="icon-treesourceshanshui"></i>
                    <span slot="title" class="systemTitle">在线考试系统</span>
                </el-menu-item>                 
                <el-submenu  index='1' v-show="role == 'super_admin'">
                    <template slot="title">    
                        <i  class="icon-treesourcexitong menuIcon"></i>
                        <span slot="title" class="menuTitle">系统管理</span>             
                    </template>
                    <el-menu-item index="/userManage" class="childMenu">
                        <div>用户管理</div>
                    </el-menu-item> 
                    <el-menu-item index="/roleManage" class="childMenu">
                        <div>角色管理</div>                                  
                    </el-menu-item>  
                </el-submenu>
                <el-submenu  index='2' v-show="role == 'super_admin' || role == 'examiner'">
                    <template slot="title">    
                        <i  class="icon-treesourcemonikaoshi menuIcon"></i>
                        <span slot="title" class="menuTitle">考试管理</span>             
                    </template>
                    <el-menu-item index="/questionManage" class="childMenu">
                        <div>试题管理</div>                                   
                    </el-menu-item>  
                    <el-menu-item index="/examPaperManage" class="childMenu">
                        <div>试卷管理</div>                                   
                    </el-menu-item>
                    <el-menu-item index="/examPaperSelect" class="childMenu">
                        <div>试卷抽取</div>                                   
                    </el-menu-item>              
                    <el-menu-item index="/examManage" class="childMenu">
                        <div>考试管理</div>                                  
                    </el-menu-item>
                    <el-menu-item index="/examineeManage" class="childMenu">
                        <div>考生组管理</div>                                  
                    </el-menu-item>
                </el-submenu>
                <el-submenu index='3' v-if="role == 'student'">
                    <template slot="title">
                        <i class="icon-treesourcemonikaoshi menuIcon"></i>
                        <span slot="title" class="menuTitle">考生考试</span>
                    </template>
                    <el-menu-item index="/userexamEnroll" class="childMenu">
                        <div>考试报名</div>
                    </el-menu-item>
                    <el-menu-item index="/examOnline" class="childMenu">
                        <div>在线考试</div>
                    </el-menu-item>
                    <!-- <el-menu-item index="/historyExam" class="childMenu">
                        <div>历史成绩</div>
                    </el-menu-item> -->
                </el-submenu>   
                <el-menu-item @click="downloadQuesList" v-if="false">
                    <i class="el-icon-download"></i>
                    <span slot="title" class="menuTitle">题库下载</span>
                </el-menu-item>
        </el-menu> 
        </el-aside> 
            
        <el-container>
            <!--首页头部-->
            <el-header class="header">
                <!--伸缩按钮-->
                <div class="collapse">
                    <i class="el-icon-s-fold" v-show="!isCollapse" @click="collapseMenu()"></i>  
                    <i class="el-icon-s-unfold" v-show="isCollapse" @click="collapseMenu()"></i>            
                </div>
                <!--个人中心和登出-->
                <div class="userinfo_exit">
                    <div>
                        <span>您好， {{this.username}}！</span>
                    </div>
                    <el-popover placement="bottom" trigger="hover">           
                        <div class="cursorDiv">
                            <span @click="showUserInfo()">个人中心</span>  
                        </div>
                        <el-divider class="divider"></el-divider>
                        <div class="cursorDiv">
                            <span @click="exit()">退出登录</span>
                        </div>              
                        <el-avatar :size="40" shape="square" fit="fill" slot="reference" @error="avatarErrorHandle()">
                            <img src="../assets/avatar.jpeg"/>
                        </el-avatar> 
                    </el-popover>  
                </div>
            </el-header>
            <!--首页右侧页面切换显示区域-->
            <el-main class="main_container">               
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            asideWidth:'200px',                         //侧边栏默认宽度
            openeds: ['1','2','3'],                     //默认打开父菜单
            isCollapse: false,                          //伸缩按钮标志
            username:'',                                //用户名
            role: 'student',                            //角色
            
        }
    }, 
    created(){
        this.username = JSON.parse(this.$store.state.loginInfo).relayName;
        this.role = JSON.parse(this.$store.state.loginInfo).roles[0].roleCode;
    },

    methods: {
        //菜单伸缩按钮方法
        collapseMenu(){
            this.isCollapse = !this.isCollapse;
            this.asideWidth = this.isCollapse ? '64px' : '200px';
        },
        //退出登录
        exit() {
            this.$confirm('确定退出系统?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.commit('deleteToken');
                this.$store.commit('deleteLoginInfo');
                this.$router.push({path:"/"}) //跳转到登录页面
            }).catch(() => {});
        },
        avatarErrorHandle(){
            return true;
        },
        //展示个人中心
        showUserInfo(){
            this.$router.push({
                path: "/userinfo"
            })    
        },
        //下载题库
        downloadQuesList(){
			let downloadUrl = this.$store.state.questionsDownloadUrl;
			fetch(downloadUrl).then((res) => {
				res.blob().then((blob) => {
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = '考试题库';
					a.click();
					window.URL.revokeObjectURL(url);
				});
			}).catch(_=>{
                this.$message({
                    message: '下载出错！',
                    type: 'error'
                });  
            });
        }    
    },
}
</script>

<style lang="less" scoped>   
    .el-container {
        width: 100%;
        height: 100%;
        .el-aside { 
            height: 100%;
            background-image: url("../assets/menu_bg_img.jpeg");
            .el-menu {
                height: 100%;
                opacity: 0.7;
                border-right: none;
                .icon-treesourceshanshui {
                    font-size: 25px;
                    margin-right: 15px;
                }
                .el-icon-download {
                    font-size: 20px;
                    margin-right: 20px;
                }
                .systemTitle {
                    font-size: 21px;
                    font-family: "微软雅黑";
                }
                .menuIcon {
                    font-size: 20px;
                    margin-right: 20px;
                }
                .menuTitle {
                    font-size: 18px;
                    font-family: "微软雅黑";
                }
                .childMenu {
                    padding: 0 10px 0 10px !important; 
                    text-align: center;    
                    div {
                        font-size: 15px;
                        text-align: center;   
                    }
                    div:hover {
                        background-color: #2C2D2E !important;
                    }
                }
                .childMenu.is-active {
                    div {
                        background-color: #eb0854 !important;
                    }
                }    
            }
        }
        .header {
            display: flex;        
            align-items: center;
            justify-content: space-between;
            padding-left: 5px;
            padding-right: 60px;
            .collapse i{ 
                font-size: 28px;
            } 
            .userinfo_exit {
                display: flex;
                align-items: center;                  
            }
        }
        .main_container {
            background-color: #EEEEEE;
        }
    } 
    .divider {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .cursorDiv {
        font-size: 15px;
        font-family: '微软雅黑';
        color: #606266;
        text-align: center;                 
    }
    .cursorDiv:hover{
        cursor: pointer;
        color: #46a6ff;
    }   
</style>